module.exports = __webpack_public_path__ + "media/src/images/icon/land-12e6632ea6a4c7d7a66e25bbfa9fa974.png";